/*! © 2026 AirX (airx.art). All rights reserved. Unauthorized copying, reproduction, or redistribution of this code is prohibited. Report infringement: info@airx.art */

(function () {
  'use strict';

  var WALK_KEY = 'airx:corridor:walk';
  var MAX_AGE_MS = 30 * 60 * 1000;

  var btn = document.querySelector('[data-walk-return]');
  if (!btn) return;

  var canGoBack = window.history.length > 1;
  var scriptTab = !canGoBack && !!window.opener;
  if (!canGoBack && !scriptTab) return;

  var data = null;
  try {
    data = JSON.parse(sessionStorage.getItem(WALK_KEY));
  } catch (err) {
    return;
  }
  if (!data || data.v !== 1 || data.pendingReturn !== true) return;
  if (typeof data.t !== 'number' || Date.now() - data.t > MAX_AGE_MS) return;
  if (typeof data.clickUrl !== 'string' || !data.clickUrl) return;

  var clickedPath;
  try {
    clickedPath = new URL(data.clickUrl, window.location.origin).pathname;
  } catch (err) {
    return;
  }
  if (clickedPath !== window.location.pathname) return;

  var place = function () {
    var header = document.querySelector('.header');
    if (!header) return;

    var hb = header.getBoundingClientRect().bottom + window.scrollY;
    btn.style.top = Math.max(24, Math.round(hb) + 12) + 'px';
  };
  var reveal = function () {
    place();
    btn.hidden = false;
    requestAnimationFrame(function () {
      btn.classList.add('is-visible');
    });

    if (window.ResizeObserver) {
      new ResizeObserver(place).observe(document.body);
    }
    setTimeout(place, 600);
    window.addEventListener('resize', place);
  };
  if (document.readyState === 'complete') reveal();
  else window.addEventListener('load', reveal, { once: true });
  btn.addEventListener('click', function () {
    btn.classList.remove('is-visible');
    if (scriptTab) window.close();
    else window.history.back();
  });
})();
